import { render, staticRenderFns } from "./classFile.vue?vue&type=template&id=c81a20ec"
import script from "./classFile.vue?vue&type=script&lang=js"
export * from "./classFile.vue?vue&type=script&lang=js"
import style0 from "./classFile.vue?vue&type=style&index=0&id=c81a20ec&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports